package com.netguru.multiplatform.charts.line

import androidx.compose.runtime.*
import androidx.compose.ui.graphics.*
import com.netguru.multiplatform.charts.theme.*

@Immutable
data class LineChartColors(
    val grid: Color,
    val surface: Color,
    val overlayLine: Color,
)

val ChartColors.lineChartColors
    get() = LineChartColors(
        grid = grid,
        surface = surface,
        overlayLine = overlayLine,
    )
